<template>
    <div style="display: block; clear: both">
        <div style="display: flex; flex-direction: row;">
            <el-form-item :label="names[categoryKey]" v-for="(categoryItems, categoryKey) in globals.categories"
                          :key="categoryKey" class="mr-5 pr-5" style="width: 200px;">
                <el-checkbox-group v-model="formData.categories[categoryKey]" style="display: block; clear: both">
                    <el-checkbox v-for="(d, index) in categoryItems" :key="index" :label="index" class="d-block ml-0">
                        {{ d }}
                    </el-checkbox>
                    <el-checkbox label="undefined" class="d-block ml-0">Undefined</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'formData'
    ],
    data() {
        return {
            names: {
                driver: 'Job Category',
                equipment: 'Equiment Type',
                route: 'Driving Distance',
                teams: 'Teams',
                category: 'Specialization'
            },
        }
    },
    computed: {},
    methods: {},
    mounted() {
    }
}
</script>

<style>
</style>